import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowLeft } from "lucide-react";
export default function CtaFooterSection() {
  return <section data-section-id="256600" id="footernavigation" className="relative overflow-hidden bg-background py-24 px-4 md:px-8 flex flex-col items-center justify-center text-center">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-muted/20 to-background pointer-events-none" />

      <div className="relative z-10 max-w-2xl mx-auto flex flex-col items-center">
        <div className="mb-8 flex items-center justify-center">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 15, 2026, 04_01_15 PM.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 15, 2026, 04_01_15 PM.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/ChatGPT Image May 15, 2026, 04_01_15 PM.png-wvc-sizes" alt="Industrial Supply Chain Optimization" className="h-32 w-auto object-contain" loading="lazy" decoding="async" />
        </div>

        <h2 className="font-default text-[24px] font-bold text-primary mb-4 tracking-tight">
          Ready to Optimize Your Industrial Supply Chain?
        </h2>
        
        <p className="font-default text-[16px] text-muted-foreground mb-8 max-w-lg leading-relaxed">
          Partner with Oriental World Corporation Limited for reliable commodity trading and regional logistics expertise across the Far East.
        </p>
        
        <Button asChild size="lg" className="rounded-md bg-primary text-primary-foreground hover:bg-primary/90 px-8 h-12 text-[15px] font-semibold shadow-md transition-transform hover:-translate-y-0.5">
          <Link to="/ContactPage">
            Contact Us
            <ArrowLeft className="mr-2 size-5" />
          </Link>
        </Button>
      </div>
    </section>;
}